import { normalizePageTitle, PAGE_TITLE_LIMIT } from '../pages';

/**
 * The maximum length of a reusable content title.
 */
export const REUSABLE_CONTENT_TITLE_MAX_LENGTH = PAGE_TITLE_LIMIT;

/**
 * Normalize a reusable content title.
 */
export const normalizeReusableContentTitle = normalizePageTitle;

/**
 * The fallback title for reusable content.
 */
export const REUSABLE_CONTENT_TITLE_FALLBACK = 'Untitled';

/**
 * Returns a title for reusable content, with a fallback if it does not exist.
 */
export function getReusableContentTitle(title?: string | undefined | null): string {
    return title || REUSABLE_CONTENT_TITLE_FALLBACK;
}
